import GuestCard from '../../commons/GuestCard';
import RedeemButton from './RedeemButton';
import MissingLoyaltyPoints from './MissingLoyaltyPoints';

interface Props {
  points: number;
  prizeId: number;
  isAuth: boolean;
  missingPoints: number;
}

const RedeemSection = (props: Props): JSX.Element => {
  let content = <RedeemButton points={props.points} prizeId={props.prizeId} />;

  if (!props.isAuth) {
    content = <GuestCard />;
  }

  if (props.missingPoints) {
    content = (
      <MissingLoyaltyPoints missingLoyaltyPoints={props.missingPoints} />
    );
  }

  return <section className="tw-px-4 sm:tw-px-0">{content}</section>;
};

export default RedeemSection;
